import { css } from '@emotion/react';
import t from 'react-translate';
import prodPathReplace from 'shared/prod-path-rewrite';
import { white } from 'styles/global_defaults/colors';
import { halfSpacing } from 'styles/global_defaults/scaffolding';

const styles = css`
  width: 100%;
  border-radius: ${halfSpacing}px;
  background-color: ${white};

  .placeholder-bar {
    width: 75%;
  }
  .short-bar {
    width: 50%;
  }
`;

const NextSessionLoadingPlaceholder = () => {
  const translationBase = t.MENTORING_PROGRAMS.PARTICIPANT_HOME.NEXT_SESSION;
  const altImage = translationBase.PLACEHOLDER.DATE_ALT_IMAGE();

  return (
    <div css={styles} className='d-flex'>
      <img
        src={prodPathReplace('images/calendar-placeholder.svg')}
        alt={altImage}
      />
      <div className='w-100 px-4 m-auto'>
        <div className='semi-bold gray-2'>{translationBase.TITLE()}</div>
        <div className='loading placeholder-bar short-bar ml-0 mt-2 mb-0' />
        <div className='loading placeholder-bar ml-0 mt-2' />
      </div>
    </div>
  );
};

export default NextSessionLoadingPlaceholder;
